import { getItem, removeItem, setItem } from "../helpers/localStorage";
import { clearInspectTokens } from "./inspectTokens";
import { CognitoSession } from "./types";

export const setCognitoSession = (data: CognitoSession) => {
    setItem("cognito_access_token", data.cognito_access_token);
    setItem("cognito_refresh_token", data.cognito_refresh_token || "");
    setItem("cognito_config", JSON.stringify(data.cognito_config) || "");
};

export const clearCognitoSession = () => {
    const cognitoSession = getCognitoSession();
    removeItem("cognito_access_token");
    removeItem("cognito_refresh_token");
    removeItem("cognito_config");
    clearInspectTokens();
    return cognitoSession;
};

const safeJsonParse = (value: unknown) => {
    try {
        return JSON.parse(value as string);
    } catch (e: unknown) {
        console.error(e);
    }
};

export const getCognitoSession = (): CognitoSession | undefined => {
    const cognito_access_token = getItem("cognito_access_token") || undefined;
    const cognito_refresh_token = getItem("cognito_refresh_token") || undefined;
    const cognito_config = getItem("cognito_config")
        ? safeJsonParse(getItem("cognito_config") || "")
        : undefined;
    if (cognito_access_token) {
        return {
            cognito_access_token,
            cognito_refresh_token,
            cognito_config,
        };
    }
};

export const setLastAccountId = (accountId: string) => {
    const regex = new RegExp("^[PT]{1}(?=(?:.{3}|.{8})$)[0-9]*$");
    if (!regex.test(accountId)) {
        return;
    }
    setItem("last_account_id", accountId);
};

export const getLastAccountId = () => {
    return getItem("last_account_id") || undefined;
};

export const clearLastAccountId = () => {
    removeItem("last_account_id");
};
